import { useSelectedVideo } from './useSelectedVideo';
import { useChannel } from './useChannel';
import { usePlayback } from './usePlayback';
import { makeVar, useReactiveVar } from '@apollo/client';
import { usePlayChannelText } from './usePlayChannelTexts';
import { useChannelAccessButton } from './useChannelAccessButton';
import { useVideoAccessButton } from './useVideoAccessButton';
import { useVideoPlayback } from './useVideoPlayback';

type OverlayProps = {
  playButtonText?: string;
  paidButton?: {
    text: string;
    handler(): void;
  };
  title?: string;
  coverUrl?: string;
  visible: boolean;
};

export const isChannelViewVar = makeVar<boolean>(true);

export function useOverlayProps(): OverlayProps {
  const isChannelView = useReactiveVar(isChannelViewVar);
  const { selectedVideo } = useSelectedVideo();
  const channel = useChannel();
  const { playing } = usePlayback();
  const videoPlayback = useVideoPlayback(selectedVideo);
  const playChannelText = usePlayChannelText();
  const channelAccessButton = useChannelAccessButton();
  const videoAccessButton = useVideoAccessButton(selectedVideo);

  const defaultProps: OverlayProps = {
    visible: false,
  };

  if (isChannelView) {
    return {
      playButtonText: playChannelText,
      paidButton: channelAccessButton,
      title: channel.title,
      coverUrl: channel.cover.selected,
      visible: true,
    };
  }

  if (selectedVideo) {
    return {
      playButtonText: videoPlayback?.playVideoText,
      paidButton: videoAccessButton,
      title: selectedVideo.title,
      coverUrl: selectedVideo.cover.selected,
      visible: !playing,
    };
  }

  return defaultProps;
}
